module.exports = __webpack_public_path__ + "static/img/help_01intro_04.114b09b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fdback/help_01intro_04.jpg
// module id = 678
// module chunks = 140